// extracted by mini-css-extract-plugin
export var borderRadius = "_4v-4";
export var large = "_4v-3";
export var logoContainer = "_4v-0";
export var nameLogo = "_4v-2";
export var small = "_4v-1";